import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft, Check } from "lucide-react";
import { Header } from "../sections/Header";
import { Footer } from "../sections/Footer";
import Seo from "../components/Seo";
import { ImpactIntakeForms } from "../components/ImpactIntakeForm";

const BENEFITS = [
  "Your brand attached to measurable veteran training and hiring outcomes",
  "Trees planted in your organization's name through the EVIQ Earth Initiative",
  "Feature placement across EVIQ's impact reporting and community pages",
  "Early access to co-branded sponsorship opportunities as the program scales",
];

export default function PartnersPage() {
  return (
    <div className="min-h-screen bg-black text-white" data-testid="partners-page">
      <Seo
        title="Corporate Partnerships — Verified EVIQ Impact Partner"
        description="Put your brand behind veterans entering the EV economy. The Verified EVIQ Impact Partner seal — available to approved participating EVIQ Impact Partners."
        canonical="https://eviq.pro/partners"
      />
      <Header />
      <main>
        {/* Seal hero */}
        <section className="relative pt-32 pb-16 overflow-hidden" style={{ background: "linear-gradient(180deg,#030503,#06121a)" }}>
          <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-12">
            <div className="flex-1">
              <Link to="/impact" className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-zinc-500 mb-5 hover:text-zinc-300" data-testid="partners-back-impact">
                <ArrowLeft className="w-3.5 h-3.5" /> Veteran Green Initiative
              </Link>
              <div className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.28em] mb-4 block" style={{ color: "#00E5FF" }}>
                <ShieldCheck className="w-3.5 h-3.5" /> Corporate partnerships
              </div>
              <h1 className="font-display font-semibold text-4xl sm:text-5xl leading-[1.06]">
                The <span style={{ color: "#00E5FF" }}>Verified EVIQ Impact Partner</span> seal.
              </h1>
              <p className="text-zinc-400 text-base sm:text-lg leading-relaxed mt-5 max-w-xl">
                A mark of real, verified commitment to veterans entering the EV economy — not a logo swap.
              </p>
              <div
                className="inline-flex items-center gap-2 rounded-full border px-4 py-2 mt-6 font-mono text-[11px] uppercase tracking-wider"
                style={{ borderColor: "rgba(0,229,255,0.45)", color: "#A9EDFF", background: "rgba(0,229,255,0.07)" }}
                data-testid="partners-seal-availability"
              >
                <ShieldCheck className="w-4 h-4" style={{ color: "#00E5FF" }} />
                Available to approved participating EVIQ Impact Partners
              </div>
            </div>
            <img
              src="/impact-partner-seal.png"
              alt="Verified EVIQ Impact Partner seal"
              className="w-64 h-64 sm:w-80 sm:h-80 object-contain shrink-0 rounded-full"
              style={{ filter: "drop-shadow(0 0 40px rgba(0,229,255,0.25))" }}
              data-testid="partners-seal-image"
            />
          </div>
        </section>

        {/* Benefits */}
        <section className="py-14 border-y" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
          <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="font-mono text-[10px] uppercase tracking-[0.24em] mb-4" style={{ color: "#39FF14" }}>
              What partnership includes
            </div>
            <div className="space-y-3">
              {BENEFITS.map((b) => (
                <div key={b} className="flex items-start gap-3 text-zinc-300 text-sm sm:text-base leading-relaxed">
                  <Check className="w-4 h-4 mt-1 shrink-0" style={{ color: "#39FF14" }} /> {b}
                </div>
              ))}
            </div>
            <p className="font-mono text-[10px] text-zinc-600 leading-relaxed mt-6 max-w-xl">
              Seal usage is granted only after EVIQ's partner verification standards are met. Submitting
              interest does not confer certification. EVIQ is not currently operating a charitable fund and
              contributions are not tax-deductible.
            </p>
          </div>
        </section>

        {/* Partner intake forms */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8">
            <h2 className="text-white font-semibold text-2xl sm:text-3xl mb-8">
              Start the conversation.
            </h2>
            <ImpactIntakeForms types={["training_partner", "employer_partner", "esg_partner"]} defaultType="training_partner" />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
